<template>
  <div class="container" v-if="loaded">
    <!-- 弹幕 -->
    <BulletScreen />
    <!-- 用户拼团信息 -->
    <div class="pink">
      <div class="title" v-if="!buyed">我的团仅差1人，快来上课吧</div>
      <!-- 参与拼团的人 -->
      <div class="members">
        <div class="item active">
          <img :src="user.avatar" />
        </div>
        <div class="item" v-if="!buyed">
          <img :src="require('@/assets/icons/none.png')" />
        </div>
        <div class="item active" v-if="buyed">
          <img :src="my.avatar" />
        </div>
      </div>
      <div class="title" v-if="buyed">恭喜！拼团已成功，您可以观看此课程</div>
      <!-- 立即参团 -->
      <div class="invite-btns" v-if="!buyed">
        <button class="invite" @click="pinkBuy">¥{{subject.invitePrice}}元 立即参团</button>
      </div>
      <!-- 观看课程 -->
      <div class="view-btns" v-if="buyed">
        <div class="view-btn" @click="toView">观看课程</div>
        <div class="view-btn" @click="createPoster">邀请好友，赚奖金</div>
      </div>
      <!-- 奖学金信息 -->
      <div class="bonus-info" v-if="buyed">
        <span>已得奖学金：¥{{my.totalAmount}}</span>
        <span>已提现：¥{{my.withdrawTotalAmount}}</span>
      </div>
    </div>
    <div class="invite-friend" v-if="buyed" @click="toProfit">
      <div class="invite-friend--content">邀请好友，赚{{subject.bonus}}元</div>
    </div>
    <Poster :show="showPosterPopup" :posterData="posterData" @close="showPosterPopup=false" />
    <!-- 课程详情 -->
    <SubjectDetail :subject="subject" v-if="subject" />
    <!-- 购买弹窗 -->
    <van-action-sheet v-model="showSheet" class="pay_box" title="课程详情" @close="cancelConfirm()" :close-on-click-overlay="false">
      <div class="shop_tab tab">
        <div class="img fl">
          <img :src="require('@/assets/icons/goods.png')" />
        </div>
        <div class="text fl">课程名称</div>
        <div class="name fr">{{ subject.title }}</div>
      </div>
      <div class="buyway_tab tab">
        <div class="img fl">
          <img :src="require('@/assets/icons/buyway.png')" />
        </div>
        <div class="text fl">购买方式</div>
        <div class="name fr">拼团购买</div>
      </div>
      <div class="pay_tab tab">
        <div class="img fl">
          <img :src="require('@/assets/icons/pay.png')" />
        </div>
        <div class="text fl">支付总额</div>
        <div class="name fr"><span>￥</span><span class="num">{{ subject.invitePrice }}</span></div>
      </div>
      <button class="sure_pay" @click="sendOrder">确定支付</button>
    </van-action-sheet>
  </div>
</template>
<script>
import wx from 'weixin-js-sdk'
import { createOrder, getOrderInfo, getInviteInfo } from './query.gql'
import SubjectDetail from '@/pages/subject/detail'
import Poster from '@/components/Poster'
import BulletScreen from '@/components/BulletScreen'
export default {
  name: 'invite',
  data() {
    return {
      loaded: false,
      subject: '',
      user: '',
      my: '',
      showSheet: false,
      buyed: false,
      showPosterPopup: false,
      posterData: null
    }
  },
  components: {
    SubjectDetail,
    Poster,
    BulletScreen
  },
  methods: {
    loadData() {
      // 请求数据
      const self = this
      self.$toast.loading({
        mask: true,
        duration: 0,
        message: '加载中'
      })
      self.$apollo.query({
        query: getInviteInfo,
        variables: {
          subjectId: self.subjectId,
          code: self.invitationCode
        },
        fetchPolicy: 'no-cache'
      }).then(res => {
        console.log(res)
        self.$toast.clear()
        // 前置判断
        // 1.用户没有购买过该课程
        // 2.用户购买过该课程
        // 2.1 用户全价购购买的 -》
        // 2.2 用户拼团购购买的 -》
        // 2.3 用户邀请购购买的 -》
        // 2.4 用户分销购购买的 -》
        self.user = res.data.userProfile
        self.subject = res.data.subject
        self.my = res.data.profile
        if (self.my.isDistributor) {
          self.$router.replace({
            name: 'subject',
            query: { id: self.subject.id }
          })
        } else {
          if (self.subject.orderInfo) {
            switch (self.subject.orderInfo.types) {
              case 'full_buy':
                self.$router.replace({
                  name: 'classroom'
                })
                break
              case 'pink_buy':
                self.$router.replace({
                  name: 'groupShare',
                  params: { id: self.subject.orderInfo.pink.id }
                })
                break
              case 'invite_buy':
                if (self.subject.orderInfo.status === 'paid') {
                  self.buyed = true
                  self.user = self.subject.orderInfo.parentUser
                  self.invitationCode = self.user.invitationCode
                }
                break
              case 'distribute_buy':
                self.$router.replace({
                  name: 'subject',
                  query: { id: self.subject.id }
                })
                break
            }
          }
        }
        self.loaded = true
        // self.$zhuge.identify(self.my.id, {
        //   name: self.my.nickname,
        //   avatar: self.my.avatar
        // })
      }).catch(err => {
        console.error('page：invite/index。请求getInviteInfo报错', err)
        self.$toast.fail('加载数据出错')
      })
    },
    // 拼团购买
    pinkBuy() {
      this.showSheet = true
    },
    // 取消确认
    cancelConfirm() {
      const self = this
      console.log('showSheet', self.showSheet)
      if (self.showSheet) {
        self.$dialog.confirm({
          message: '确认取消付款？',
          confirmButtonText: '继续支付',
          confirmButtonColor: '#ff4e00',
          cancelButtonText: '取消支付'
        }).then(() => {
          self.showSheet = true
        }).catch(() => {
          this.shopSheet = false
          console.log('TODO: 取消订单')
        })
      }
    },
    // 下单
    sendOrder() {
      const self = this
      self.$toast({
        type: 'loading',
        mask: true,
        duration: 0,
        message: '提交中'
      })
      // 用户未购买此课程
      let variables = {
        subjectId: self.subject.id,
        types: 'invite_buy',
        invitationCode: self.invitationCode
      }
      console.log('下单参数', variables)

      self.$apollo.mutate({
        mutation: createOrder,
        variables
      }).then(res => {
        console.log('下单结果', res)
        self.showSheet = false
        let result = res.data.createOrderMutation
        if (result.order.totalFee > 0) {
          wx.chooseWXPay({
            timestamp: result.timeStamp,
            nonceStr: result.nonceStr,
            package: result.package,
            signType: result.signType,
            paySign: result.paySign,
            success() {
              self.$toast.clear()
              self.polling(result.order.tranNo)
            },
            cancel() {
              self.$toast.clear()
              self.$toast('支付已取消')
            },
            fail() {
              self.$toast.clear()
              self.$toast.fail('支付失败')
            }
          })
        } else {
          self.$toast.clear()
          self.polling(result.order.tranNo)
        }
      }).catch(err => {
        console.error('page: group/success。请求createOrder报错', err)
        self.$toast.clear()
        self.$toast.fail(err.graphQLErrors[0].message || '下单失败')
      })
    },
    // 轮询
    polling(tranNo) {
      const self = this
      self.$toast({
        type: 'loading',
        mask: true,
        duration: 0,
        message: '支付中'
      })
      let pollTimes = self.$consts.POLLING_TIMES || 5 // 默认轮询五次
      let timer = setInterval(() => {
        pollTimes -= 1
        if (pollTimes >= 0) {
          self.$apollo.query({
            query: getOrderInfo,
            variables: { tranNo },
            fetchPolicy: 'no-cache'
          }).then(res => {
            if (res.data.order.status === 'paid') {
              self.$toast.clear()
              clearInterval(timer)
              // 购买完成，刷行数据
              self.loadData()
            }
          }).catch(err => {
            console.error('page: invite/index。（轮询）请求getOrderInfo报错', err)
          })
        } else {
          // 超过5次轮询没有结果怎么办？？
          self.$toast.clear()
        }
      }, self.$consts.POLLING_INTERVAL || 2000)
    },
    toView() {
      this.$router.replace({
        name: 'classroom'
      })
    },
    toProfit() {
      this.$router.replace({
        name: 'profit'
      })
    },
    createPoster() {
      // 生成海报
      const self = this
      self.posterData = {
        user: {
          avatar: self.my.avatar,
          nickname: self.my.nickname
        },
        posterTplImg: self.subject.posterTplImg,
        wxShareLink: `${window.location.origin}/?#/invite/${self.subject.id}?invitationCode=${self.my.invitationCode}`
      }
      self.showPosterPopup = true
    }
  },
  async mounted() {
    await this.weixinAuth()
    this.wechatPay()
    this.subjectId = parseInt(this.$route.params.id)
    this.invitationCode = this.$route.query.invitationCode
    this.loadData()
  }
}
</script>
<style lang="scss" scoped>
  .container{
    .pink {
      background: #fff;
      padding-bottom: 20px;
      .title {
        font-size: 17.5px;
        color: #333;
        padding: 20px 0 15px;
        font-weight: bold;
        text-align: center;
        letter-spacing: 2px;
        span {
          color: #fa512d;
          font-size: 21px;
          font-weight: bold;
        }
      }
      .members {
        overflow: hidden;
        padding-bottom: 25px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-wrap: wrap;
        .item {
          width: 50px;
          height: 50px;
          margin-right: 17.5px;
          padding: 2.5px;
          box-sizing: border-box;
          margin-top: 6px;
          position: relative;
          &:last-child {
            margin-right: 0;
          }
          img {
            width: 100%;
            height: 100%;
            border-radius: 50%;
          }
          &.active {
            background: url('~@/assets/images/groupUserHasPayBg.png') no-repeat center / 100%;
          }
        }
      }
      .invite-btns {
        height: 46.5px;
        padding-bottom: 7.5px;
        position: relative;
        .invite {
          font-size: 20px;
          height: 46.5px;
          width: 278px;
          line-height: 46.5px;
          font-weight: bold;
          text-align: center;
          margin: 0 auto;
          border-radius: 25px;
          color: #fff;
          position: absolute;
          left: 50%;
          margin-left: -139px;
          background: linear-gradient(to top, #ff4800,#ff9600);
          box-shadow: 0 0 8px #ff8f00;
          border: none;
          outline: none;
          cursor: pointer;
          -webkit-appearance: none;
          animation: pulse 1s infinite;
        }
      }
    }
    .pay_box {
      font-size: 15.36px;
      border-radius: 9.6px 9.6px 0 0;
      .fl {
        float: left;
      }
      .fr {
        float: right;
      }
      img {
        width: 100%;
      }
      .tab {
        overflow: hidden;
        height: 38.3906px;
        line-height: 38.3906px;
        padding: 0 26.88px;
        border-bottom: 0.46875px solid #f7f7f7;
        .img {
          padding-top: 9.6px;
          padding-right: 12.48px;
          width: 18.7188px;
        }
        .text {
          font-size: 17.28px;
          color: #333;
        }
        .name {
          font-size: 14.4px;
          color: #666;
          padding-right: 4.8px;
        }
      }
      .sure_pay {
        display: block;
        margin: 0 auto 22.56px;
        width: 92%;
        height: 45.1094px;
        border-radius: 22.56px;
        line-height: 45.12px;
        font-size: 18.72px;
        color: #fff;
        text-align: center;
        background-color: #ff6000;
        margin: 15.36px 14.4062px 24px;
      }
      .sure_pay {
        display: block;
        margin: 0 auto 22.56px;
        width: 92%;
        height: 45.1094px;
        border-radius: 22.56px;
        line-height: 45.12px;
        font-size: 18.72px;
        color: #fff;
        text-align: center;
        background-color: #ff6000;
        margin: 15.36px 14.4062px 24px;
        border: unset;
      }
    }
    .view-btns {
      display: flex;
      color: #fff;
      overflow: hidden;
      box-sizing: border-box;
      .view-btn {
        flex: 1;
        padding: 15px 0;
        background-color: #F09E38;
        text-align: center;
        margin: 0 15px;
        border-radius: 28px;
        &:nth-of-type(2){
          background-color: #E75E3D;
        }
      }
    }
    .invite-friend{
      position: fixed;
      left: 22.5px;
      right: 22.5px;
      bottom: 20px;
      z-index: 999;
      .invite-friend--content{
        position: relative;
        width: 100%;
        height: 55px;
        line-height: 55px;
        text-align: center;
        font-size: 22px;
        font-weight: 600;
        color: #EC6E36;
        background: url('~@/assets/icons/invite_btn.png') center center no-repeat;
        background-size: 100% 100%;
        animation: invite_firend_btn .25s linear infinite alternate;
      }
    }
    .bonus-info{
      display: flex;
      padding-top: 20px;
      color: #333;
      font-size: 14px;
      span{
        display: block;
        flex: 1;
        text-align: center;
      }
    }
  }
</style>
